// Sanitização de URLs externas usadas em href (defesa contra javascript:/data:).
//
// O cardápio é PÚBLICO e o link do WhatsApp vem do backend (campo do tenant). Um
// href malicioso (javascript:, data:) executaria no contexto da página, então só
// deixamos passar esquemas seguros. Sem esquema explícito, assume https
// (ex.: "wa.me/55…" → "https://wa.me/55…").
export function safeExternalUrl(raw: string | null | undefined): string | null {
  if (!raw) return null;
  let v = String(raw).trim();
  if (!v) return null;
  if (!/^[a-z][a-z0-9+.-]*:/i.test(v)) v = 'https://' + v; // sem esquema → https
  try {
    const u = new URL(v);
    return ['http:', 'https:', 'mailto:', 'tel:'].includes(u.protocol) ? u.href : null;
  } catch {
    return null;
  }
}
